import { jsxs as l, Fragment as C, jsx as e } from "react/jsx-runtime";
const d = () => /* @__PURE__ */ l(C, { children: [
  /* @__PURE__ */ e(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.21459 4.94412C7.57164 4.73416 8.0313 4.8534 8.24126 5.21045L16.552 19.3434C16.7619 19.7004 16.6427 20.1601 16.2856 20.3701C15.9286 20.58 15.4689 20.4608 15.2589 20.1037L6.94825 5.9708C6.73829 5.61374 6.85753 5.15408 7.21459 4.94412Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ e(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.25 8.45676V17C7.25 17.0849 7.25604 17.1683 7.26772 17.25H5C4.58579 17.25 4.25 17.5858 4.25 18C4.25 18.4142 4.58579 18.75 5 18.75H9H12H13.3028L7.25 8.45676ZM16.203 18.75H15H14.4629L14.0219 18H14.5V15.8539L16.203 18.75ZM17.3631 18.75H18.5C18.9142 18.75 19.25 18.4142 19.25 18C19.25 17.5858 18.9142 17.25 18.5 17.25H16.7323C16.744 17.1683 16.75 17.0849 16.75 17V10C16.75 9.0335 15.9665 8.25 15 8.25H14.5L14.5 13.8811L17.3631 18.75ZM13.5 12.1805L13.5 5.0981C13.1938 4.5899 12.6366 4.25 12 4.25H9C8.91247 4.25 8.82644 4.25643 8.74235 4.26883C8.88188 4.39 9.00444 4.5355 9.10328 4.70359L13.5 12.1805ZM7.25 6.48396V6C7.25 5.55787 7.41396 5.15404 7.68439 4.84598C7.90856 4.87313 8.11797 5.0008 8.24127 5.21048L13.5 14.1533V17.1125L7.25 6.48396Z",
      fill: "currentColor"
    }
  )
] });
export {
  d as default
};
